module.exports = __webpack_public_path__ + "img/storm_clouds.fa499c4d.png";